import { useI18n } from "../i18n";

const ContactHero = () => {
    const { contact } = useI18n();

    return (
        <section className="relative isolate overflow-hidden bg-slate-50 px-6 pb-16 pt-36 text-slate-900 md:px-12 md:pb-20 md:pt-44">
            {/* Abstract background */}
            <div
                aria-hidden="true"
                className="pointer-events-none absolute inset-0 -z-10 overflow-hidden"
            >
                <div className="absolute -right-32 -top-40 h-[28rem] w-[28rem] rounded-full bg-sky-200/50 max-sm:hidden" />

                <div className="absolute -bottom-48 -left-32 h-[30rem] w-[30rem] rounded-full bg-blue-100/70" />

                <div
                    className="absolute inset-0 opacity-[0.035]"
                    style={{
                        backgroundImage:
                            "linear-gradient(to right, #334155 1px, transparent 1px), linear-gradient(to bottom, #334155 1px, transparent 1px)",
                        backgroundSize: "55px 55px",
                    }}
                />

                <svg
                    className="absolute inset-0 h-full w-full"
                    viewBox="0 0 1440 500"
                    preserveAspectRatio="xMidYMid slice"
                    fill="none"
                >
                    <defs>
                        <linearGradient
                            id="contactHeroGradient"
                            x1="0"
                            y1="0"
                            x2="1440"
                            y2="500"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#38BDF8" stopOpacity="0" />
                            <stop offset=".5" stopColor="#38BDF8" stopOpacity=".5" />
                            <stop offset="1" stopColor="#6366F1" stopOpacity="0" />
                        </linearGradient>
                    </defs>

                    <path
                        d="M-100 350C200 150 350 500 650 270S1100 100 1540 300"
                        stroke="url(#contactHeroGradient)"
                        strokeWidth="1.5"
                    />

                    <path
                        d="M800 -100C900 100 1100 150 1300 50S1500 150 1600 250"
                        stroke="url(#contactHeroGradient)"
                        strokeWidth="1.5"
                    />

                    <circle
                        cx="1150"
                        cy="150"
                        r="90"
                        stroke="#38BDF8"
                        strokeOpacity=".25"
                    />

                    <circle
                        cx="1150"
                        cy="150"
                        r="120"
                        stroke="#38BDF8"
                        strokeOpacity=".15"
                    />
                </svg>
            </div>

            <div className="mx-auto max-w-7xl">
                <div className="contact-hero-content">
                    <p className="mb-5 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.24em] text-sky-700 sm:text-sm">
                        <span className="h-px w-8 bg-sky-600" />
                       {contact.companyName}
                    </p>

                    <h1 className="max-w-4xl text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl md:text-7xl">
                        {contact.heroTitle}
                    </h1>

                    <p className="mt-6 max-w-2xl text-base leading-7 text-slate-600 sm:text-lg sm:leading-8">
                        {contact.heroDescription}
                    </p>

                    <div className="mt-8 h-1 w-24 rounded-full bg-gradient-to-r from-sky-500 to-blue-400" />
                </div>
            </div>

            <style>{`
                .contact-hero-content {
                    animation: contactHeroAppear 450ms ease-out both;
                }

                @keyframes contactHeroAppear {
                    from {
                        opacity: 0;
                        transform: translateY(12px);
                    }

                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @media (prefers-reduced-motion: reduce) {
                    .contact-hero-content {
                        animation: none;
                    }
                }
            `}</style>
        </section>
    );
};

export default ContactHero;